export default "__VITE_ASSET__9bf278a4__"